export enum EmploymentPreferenceName {
    hideCrossSellingComponent = 'hideCrossSellingComponent',
}
